import * as React from 'react';

interface UseCreateWorkspaceFolderDialogParams {
  canCreateFolder: boolean;
}

export function useCreateWorkspaceFolderDialog({
  canCreateFolder,
}: UseCreateWorkspaceFolderDialogParams) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = () => {
    if (canCreateFolder) {
      setIsOpen(true);
    }
  };

  const close = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    open,
    close,
  };
}
